/**
 * route paths
 */

'use strict';

angular.module('cvsApp').service('cvsAppData', function () {

	function cvsAppData() {
	}

	return new cvsAppData();
});